module.exports = __webpack_public_path__ + "static/media/distribuicao-4.cfa9b96e.jpg";